import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * U9 (2026-07-05): re-skinned to the house text-input voice (`.ui-input`,
 * components.css) — the previous Tailwind utility string was inert
 * (tailwind.css was never imported; dependency removed in U8), so every
 * <Input> rendered as a bare native input.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn("ui-input", className)}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
